import React from "react";
import { useAppointmentFees } from "../../../hooks/useAppointmentFees";
import { useContext } from "../../../context";
import { FEE_MODAL_TYPE } from "../../Modals/Fee/config";
import { useCancelNotificationFlow } from "../../../hooks/useCancelNotificationFlow";

export function Cancel() {
  const { modals } = useContext();
  const { cancelationFee, isLoading } = useAppointmentFees();
  const notificationFlow = useCancelNotificationFlow();

  const onCancel = () => {
    if (cancelationFee) {
      modals.fee.open({
        type: FEE_MODAL_TYPE.cancelation,
        cancelationFee,
      });
    } else {
      notificationFlow.start();
    }
  };

  return (
    <button
      className="new-red-btn"
      onClick={onCancel}
      disabled={isLoading || notificationFlow.isLoading}
    >
      Cancel Appointment
    </button>
  );
}
